const _AUTHORIZATION = 'Basic NlJOUlYxRkMzMVAyRFRYTUpaWkc0Q1Y4WUVXRFk1Wjc6';
const _PRODUCT = '/api/products';
const _PRODUCT_COMBINATION = '/api/combinations';
export const _CATEGORIES = '/api/categories';
const _CATEGORY_IMAGE = '/api/images/categories';
const _COLLECTION = '/api/collections';
const _PRODUCT_IMAGE = '/api/images/products';
const _PRODUCT_ATTRIBUTE = '/api/product_option_values';
export const _PRODUCT_FEATURE_VALUE = '/api/product_feature_values';
export const _PRODUCT_FEATURE_NAME = '/api/product_features';
const _PRODUCT_OPTION_VALUES = '/api/product_option_values/';
const _PRODUCT_CONTROLLER_URL = 'index.php?controller=product&id_product=';


import {getTypeFilterAttribute} from './type'


/**
 *
 * @returns {string}
 */
export const getAuthorization = () => {
    return _AUTHORIZATION;
}

/**
 *
 * @type {{params: {output_format: string}}}
 */
export const config = {
    params: {
        output_format: 'JSON'
    }
}


/**
 *
 * @type {{responseType: string}}
 */
export const configImage = {
    responseType: 'blob'
}

/**
 *
 * @type {{params: {output_format: string, display: string}}}
 */
export const configFull = {
    params: {
        output_format: 'JSON',
        display: "full"
    }
}

/**
 *
 * @param id
 * @param type
 * @returns {{params: {filter: string[], output_format: string}}}
 */
export const configFilter = (id, type) => {

    let filterKey = type === getTypeFilterAttribute() ? 'filter[id_attribute_group]' : 'filter[id_feature]';

    return {
        params: {
            output_format: 'JSON',
            display: "full",
            [filterKey]: id
        }
    }
}

/**
 *
 * @param id
 * @returns {string}
 */
export const productUrl = (id) => {
    return _PRODUCT + '/' + id;
}

/**
 *
 * @param id
 * @returns {string}
 */
export const categorieUrl = (id) => {
    return _CATEGORIES + '/' + id;
}

/**
 *
 * @param type
 * @param id
 * @returns {string}
 */
export const collectionWithType = (type, id) => {
    return _COLLECTION + '-' + type + '/' + id;
}

/**
 *
 * @param idProduct
 * @param idImage
 * @returns {string}
 */
export const productImageUrl = (idProduct, idImage) => {
    return _PRODUCT_IMAGE + '/' + idProduct + '/' + idImage;
}

/**
 *
 * @param idCategory
 * @returns {string}
 */
export const categoryImageUrl = (idCategory) => {
    return _CATEGORY_IMAGE + '/' + idCategory;
}

/**
 *
 * @param idCollection
 * @returns {string}
 */
export const collectionImageUrl = (idCollection) => {
    return '/img/collection/c/' + idCollection + '.jpg';
}

/**
 *
 * @param baseUrl
 * @param idProduct
 * @returns {string}
 */
export const getUrlProduct = (baseUrl, idProduct) => {
    return baseUrl + _PRODUCT_CONTROLLER_URL + idProduct;
}

/**
 *
 * @param idCombination
 * @returns {string}
 */
export const getUrlProductCombination = (idCombination) => {
    return _PRODUCT_COMBINATION + idCombination;
}

/**
 *
 * @param idProductOptionValues
 * @returns {string}
 */
export const getUrlProductOptionValues = (idProductOptionValues) => {
    return _PRODUCT_OPTION_VALUES + idProductOptionValues;
}

/**
 *
 * @param id
 * @returns {string}
 */
export const getAttributeValue = {
    _PRODUCT_ATTRIBUTE
}

/**
 *
 * @param id
 * @returns {string}
 */
export const getFeatureValue = {
    _PRODUCT_FEATURE_VALUE
}

/**
 *
 * @type {{_PRODUCT_FEATURE_NAME: string}}
 */
export const getFeatureName = {
    _PRODUCT_FEATURE_NAME
}

/**
 *
 * @param type
 * @returns {string}
 */
export const filterValues = (type) => {

    return type === getTypeFilterAttribute() ? _PRODUCT_ATTRIBUTE : _PRODUCT_FEATURE_VALUE;
}



// WEBPACK FOOTER //
// ./src/api/index.js